import register from 'preact-custom-element'
import useDetectBreakpoint from 'hooks/useDetectBreakpoint'
import { useEffect, useState, useRef } from 'preact/hooks'
import Icon from 'snippets/icon/icon'

function RegionSelector({ isOnMenu = false }) {
  const { enable, regions } = regionData
  const { isDesktop } = useDetectBreakpoint()
  const [regionCurrent, setRegionCurrent] = useState(regions[0])
  const [isExpand, setIsExpand] = useState(false)
  const selectRegion = useRef(null)
  const regionEl = useRef(null)

  const handleSelectChange = (e) => {
    const value = e.target.value
    const regionSelected = regions.find((item) => item.code === value)

    if (regionSelected) {
      window.location.href = getRegionLink(regionSelected)
    }
  }

  const getRegionLink = (item) => {
    return `${item.domain}?region=${item.code}&currency=${item.currencyList}`
  }

  const handleToggleRegion = () => {
    if (isDesktop) {
      setIsExpand(!isExpand)
    }
  }

  const handleClickOutside = (e) => {
    if (!isDesktop) return

    if (regionEl.current && !regionEl.current.contains(e.target)) {
      setIsExpand(false)
    }
  }

  useEffect(() => {
    const href = window.location.href
    const isRegionCurrent = regions.length > 0 && regions.find((item) => href.includes(item.domain))

    if (isRegionCurrent) {
      setRegionCurrent(isRegionCurrent)
    }
  }, [])

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return (
    enable &&
    regions.length > 0 && (
      <div ref={regionEl} className={`relative ${isOnMenu ? 'lg:w-fit' : 'md:w-fit'}`}>
        <button
          className={`flex h-12 w-fit cursor-pointer items-center justify-center gap-2 rounded-full border border-grey-300 px-[18px] py-2.5 md-max:w-full lg:min-w-[117px] ${
            isOnMenu ? 'lg-max:w-full' : 'md-max:w-full'
          }`}
          onClick={handleToggleRegion}
        >
          <Icon name="icon-global" className="h-6 w-6 text-grey-700" viewBox="0 0 24 24" />
          <span className="text-hxs font-medium uppercase text-grey-900">{regionCurrent.name}</span>
          <Icon name="icon-chevron-down" className="h-3 w-3 text-grey-700" viewBox="0 0 20 20"></Icon>
        </button>
        <select ref={selectRegion} onChange={handleSelectChange} className="absolute inset-0 opacity-0 lg:hidden">
          {regions.map((item) => (
            <option className="uppercase" selected={item.code === regionCurrent.code} key={item.code} value={item.code}>
              {item.name}
            </option>
          ))}
        </select>
        <div
          className={`absolute left-0 right-0 top-full z-1 mt-2 hidden w-full border border-default bg-grey-100 p-2 [&.active]:block ${
            isExpand ? 'active' : ''
          }`}
        >
          {regions.map((item) => (
            <a
              className="link block py-2 text-hxs font-medium uppercase text-grey-900 no-underline hover:underline"
              href={getRegionLink(item)}
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
    )
  )
}

register(RegionSelector, 'region-selector', ['isOnMenu'])
